import { ChangeNiasEntityRequest } from "services";

const key = "entity-change";

export interface EntityChangeData {
    error: boolean;
    request?: ChangeNiasEntityRequest;
}

export interface EntityChangeCache {
    get: () => EntityChangeData | null;
    save: (error: boolean, request?: ChangeNiasEntityRequest) => void;
    remove: () => void;
}

export const entityChangeCache = (): EntityChangeCache => {
    const get = () => {
        let cache = localStorage.getItem(key);
        return cache ? (JSON.parse(cache) as EntityChangeData) : null;
    };
    const save = (error: boolean, request?: ChangeNiasEntityRequest) => {
        const data: EntityChangeData = {
            error,
            request,
        };
        localStorage.setItem(key, JSON.stringify(data));
    };
    const remove = () => localStorage.removeItem(key);

    return {
        get,
        save,
        remove,
    };
};
